module.exports = "/_next/static/images/epn_1-040052ae08afc06eabc6896a517910f1.jpeg";